import React from "react";

import Item from './Item';

const Items = ({items, active, select, template, properties}) => {


  return <div className="import-rss__items">
    {items.map((item, index) => (
      <Item {...item}
            key={index}
            active={active}
            select={select}
            template={template}
            properties={properties}
      />
    ))}
    </div>
}

export default Items;
